import { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { api } from '../services/api';
import { Users as UsersIcon, Shield, ChevronRight, Sun, Moon } from 'lucide-react';
import '../styles/SharedStyles.css';

const Users = () => {
  const { t } = useLanguage();
  const { isAdmin } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isAdmin) {
      api.users.getAll()
        .then(data => {
          setUsers(Array.isArray(data) ? data : []);
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [isAdmin]);

  if (!isAdmin) {
    return <div className="container text-center mt-8 text-danger">{t('accessDenied')}</div>;
  }

  return (
    <div className={`shared-page ${theme}`}>
      <div className="glow-effect glow-1"></div>
      <div className="glow-effect glow-2"></div>
      <div className="container shared-content" style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>

      <div className="shared-section-header">
        <h2><UsersIcon size={28} /> {t('users')}</h2>
        <p>{t('usersPageSubtitle')}</p>
      </div>

      {loading ? (
        <div className="shared-loading">
          <div className="shared-spinner"></div>
          <span>{t('loading')}</span>
        </div>
      ) : users.length === 0 ? (
        <div className="shared-empty">
          <UsersIcon size={48} />
          <p>{t('noUsers')}</p>
        </div>
      ) : (
        <div className="shared-grid">
          {users.map(user => {
            const isAdmin = user.role === 'admin';
            const isActive = user.status === 'active';
            const iconColor = isAdmin ? '#8b5cf6' : isActive ? '#10b981' : '#f59e0b';
            return (
              <div key={user.id} className="shared-feature-card" style={{ '--card-color': iconColor }}>
                <div className="shared-card-icon" style={{ backgroundColor: iconColor }}>
                  {isAdmin ? <Shield size={28} /> : <UsersIcon size={28} />}
                </div>
                <h3>{user.email}</h3>
                <p className="shared-card-type">{isAdmin ? t('administrator') : t('user')}</p>
                <p className="shared-card-desc">
                  {t('createdAt')}: {new Date(user.createdAt).toLocaleDateString()}
                </p>
                <span
                  style={{
                    display: 'inline-block',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '9999px',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    marginTop: '0.75rem',
                    background: isActive ? 'rgba(16, 185, 129, 0.15)' : 'rgba(245, 158, 11, 0.15)',
                    color: isActive ? '#10b981' : '#f59e0b',
                    border: `1px solid ${isActive ? 'rgba(16, 185, 129, 0.3)' : 'rgba(245, 158, 11, 0.3)'}`
                  }}
                >
                  {user.status}
                </span>
                <div className="shared-card-arrow">
                  <ChevronRight size={20} />
                </div>
              </div>
            );
          })}
        </div>
      )}
      </div>
    </div>
  );
};

export default Users;
